import styled from "styled-components";
import { Link } from "react-router-dom";
import { theme } from "styles/theme";

export const ListContainer = styled.div`
  width: 100%;
  background-color: ${theme.colors.surface};
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

export const DeviceItem = styled.div<{
  isSelected?: boolean;
  $hasAlarm?: boolean;
  alarmSeverity?: string;
}>`
  padding: 1rem;
  border-bottom: 1px solid ${theme.colors.lightGrey};
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  background-color: ${(props) =>
    props.isSelected ? "rgba(255, 210, 0, 0.15)" : "transparent"};
  ${(props) =>
    props.$hasAlarm &&
    `border-left: 4px solid ${
      props.alarmSeverity === "Error"
        ? "#FF3B30"
        : props.alarmSeverity === "Warning"
        ? "#FF9500"
        : "#28a745"
    };`}

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: ${(props) =>
      props.isSelected ? "rgba(255, 210, 0, 0.15)" : "rgba(0, 0, 0, 0.02)"};
  }
`;

export const DisabledDeviceItem = styled(DeviceItem)`
  opacity: 0.7;
  cursor: not-allowed;

  &:hover {
    background-color: transparent;
  }
`;

export const DeviceMainInfo = styled.div`
  flex-grow: 1;
`;

export const DeviceName = styled.h3`
  margin: 0 0 5px 0;
  color: ${theme.colors.textPrimary};
  font-size: 1rem;
`;

export const DeviceSecondaryInfo = styled.div`
  display: flex;
  color: ${theme.colors.darkGrey};
  font-size: 0.875rem;
  gap: 1rem;
`;

export const StatusInfo = styled.div`
  display: flex;
  align-items: center;
  min-width: 120px;
`;

export const StatusBadge = styled.span<{ status: string }>`
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  background-color: ${(props) => {
    switch (props.status) {
      case "accepted":
        return "#d4edda";
      case "pending":
        return "#fff3cd";
      case "rejected":
        return "#f8d7da";
      default:
        return "#e9ecef";
    }
  }};
  color: ${(props) => {
    switch (props.status) {
      case "accepted":
        return "#155724";
      case "pending":
        return "#856404";
      case "rejected":
        return "#721c24";
      default:
        return "#495057";
    }
  }};
`;

export const ViewButton = styled(Link)`
  padding: 0.5rem 0.75rem;
  background-color: ${theme.colors.primary};
  color: ${theme.colors.onPrimary};
  text-decoration: none;
  border-radius: 4px;
  font-weight: ${theme.fontWeights.medium};
  font-size: 0.875rem;
  transition: background-color 0.2s;
  white-space: nowrap;

  &:hover {
    background-color: #e6bd00;
    color: ${theme.colors.onPrimary};
  }
`;

export const StatusMessageBox = styled.div<{ status: string }>`
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  border-radius: 4px;
  background-color: ${(props) => {
    switch (props.status) {
      case "pending":
        return "#fff3cd";
      case "rejected":
        return "#f8d7da";
      default:
        return "#e9ecef";
    }
  }};
  color: ${(props) => {
    switch (props.status) {
      case "pending":
        return "#856404";
      case "rejected":
        return "#721c24";
      default:
        return "#495057";
    }
  }};
  white-space: nowrap;
`;

export const WifiIcon = styled.i<{ connected: boolean | null }>`
  margin-right: 12px;
  font-size: 1.2rem;
  color: ${
    (props) =>
      props.connected === null
        ? "#999"
        : props.connected
        ? "#28a745" // green for connected
        : "#dc3545" // red for disconnected
  };
`;

export const DeviceItemContent = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  justify-content: space-between;
`;
